export function App(): JSX.Element {
  return (
    <main>
      <h1>DineRate · Merchant</h1>
      <p>Sign in to view ratings and complaints. Implementation lands in Phase 3.</p>
      <footer><small>Maintained by Blake and team, with Kevin and Ben</small></footer>
    </main>
  );
}
